<template>
  <v-card
    class="px-3 py-1 snackbar-full listing-search-card"
    outlined
    :value="true"
  >
    <div
      class="listing-search-criteria pa-0"
      style="background-color: transparent !important"
    >
      <v-container fluid class="pt-0 px-0">
        <v-row no-gutters>
          <v-col
            cols="12"
            class="py-0 d-flex align-center justify-space-between"
          >
            <!-- Left Side: Header Icon, Title & Result Badge -->
            <div class="d-flex align-center">
              <div class="filter-header-icon-wrap mr-2">
                <v-icon color="#0284c7" small>mdi-tune-variant</v-icon>
              </div>
              <span class="filter-header-title text-uppercase font-weight-700">
                Filters Applied
              </span>
              <v-chip
                color="#e0f2fe"
                text-color="#0369a1"
                x-small
                class="ml-2 font-weight-700 filter-count-chip"
              >
                {{ result }} {{ result === 1 ? "result" : "results" }}
              </v-chip>
            </div>

            <!-- Right Side: Controls (Minimize/Maximize, Edit, Reset) -->
            <div class="d-flex align-center justify-end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    x-small
                    class="mr-1 filter-action-btn"
                    @click="isMinimized = !isMinimized"
                  >
                    <v-icon color="#64748b" small>
                      {{ isMinimized ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ isMinimized ? "Expand" : "Collapse" }}</span>
              </v-tooltip>

              <v-btn
                outlined
                :disabled="dataLoading"
                x-small
                class="mx-1 px-3 filter-btn-edit font-weight-600 font-size-12"
                color="#0284c7"
                v-on:click="advancedSearch"
                depressed
              >
                <v-icon x-small class="mr-1">mdi-pencil-outline</v-icon>
                Edit
              </v-btn>

              <v-btn
                class="font-size-12 ml-1 px-3 filter-btn-reset font-weight-600"
                color="#64748b"
                outlined
                x-small
                :disabled="dataLoading"
                :loading="dataLoading"
                depressed
                v-on:click="clearSearch('clear')"
              >
                <v-icon x-small class="mr-1">mdi-refresh</v-icon>
                Reset
              </v-btn>
            </div>
          </v-col>

          <!-- Expanded Filter Chips -->
          <v-col cols="12" class="py-0" v-if="!isMinimized">
            <div class="d-flex align-center flex-wrap">
              <!-- When searchParam is set -->
              <!-- v-for="(bparam, bindex) in basicSearchFields"
                  :key="'basic-' + bindex" -->
              <template v-if="searchParam">
                <v-chip
                  small
                  class="ma-1 filter-chip"
                  close
                  @click:close="clearSearch('searchParam')"
                >
                  <span class="font-weight-600 mr-1 filter-chip-label">
                    <!-- {{
                      lodash.capitalize(lodash.toLower(getFilterLabel(bparam)))
                    }}: -->
                    Search :
                  </span>
                  <span class="filter-chip-value">{{ searchParam }}</span>
                </v-chip>
              </template>

              <!-- When searchParam is NOT set -->
              <template v-else>
                <template v-for="(param, index) in listingSearch">
                  <v-chip
                    v-if="param"
                    :key="'list-' + index"
                    small
                    class="ma-1 filter-chip"
                    close
                    @click:close="clearSearch(index)"
                  >
                    <template v-if="typeof param === 'object'">
                      <span class="font-weight-600 mr-1 filter-chip-label">
                        {{ lodash.capitalize(lodash.lowerCase(index)) }}
                        between:
                      </span>
                    </template>
                    <template v-else>
                      <span class="font-weight-600 mr-1 filter-chip-label">
                        {{ getLabelNew(index) }}:
                      </span>
                    </template>
                    <span class="filter-chip-value">
                      <template v-if="isDateRange(param)">
                        {{ formatDate(param[0]) }} - {{ formatDate(param[1]) }}
                      </template>
                      <template v-else>
                        {{ param }}
                      </template>
                    </span>
                  </v-chip>
                </template>
              </template>

              <div
                v-if="result > 0"
                class="green--text text--darken-2 font-size-12 font-weight-600 ml-2 d-flex align-center"
              >
                <v-icon color="success" x-small class="mr-1"
                  >mdi-check-circle-outline</v-icon
                >
                {{ result }} {{ result === 1 ? "result" : "results" }} found
              </div>
              <div
                v-else
                class="grey--text text--darken-1 font-size-12 font-weight-500 ml-2 d-flex align-center"
              >
                <v-icon color="grey" x-small class="mr-1"
                  >mdi-alert-circle-outline</v-icon
                >
                No results found
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import { SearchEventBus } from "@/core/lib/search.lib";
import CommonMixin from "@/core/plugins/common-mixin";
export default {
  mixins: [CommonMixin],
  props: {
    dataLoading: {
      type: Boolean,
    },
    searchEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    pageModule: {
      required: true,
      type: String,
      default: () => {
        return "";
      },
    },
    basicSearchFields: {
      type: Array,
      required: true,
      default: () => {
        return new Array();
      },
    },
    allowedSearchFields: {
      type: Array,
      required: true,
      default: () => {
        return new Array();
      },
    },
    result: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMinimized: false,
      searchParam: null,
      listingSearch: new Object(),
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      immediate: true,
      handler() {
        this.updateFields();
      },
    },
  },
  methods: {
    getAddressLineLabel(field) {
      const moduleName = this.lodash.lowerCase(this.pageModule);
      const lineNumber = {
        "address[street_1]": 1,
        "address[street_2]": 2,
        "property[street_1]": 1,
        "property[street_2]": 2,
        street_1: 1,
        street_2: 2,
      }[field];

      if (!lineNumber) {
        return null;
      }

      if (
        (moduleName === "supplier" && field.startsWith("address[")) ||
        (moduleName === "site location" &&
          (field === "street_1" ||
            field === "street_2" ||
            field.startsWith("address["))) ||
        (moduleName === "invoice" && field.startsWith("property[")) ||
        (moduleName === "purchase order" && field.startsWith("address["))
      ) {
        return `Address Line ${lineNumber}`;
      }

      return null;
    },
    isDateRange(param) {
      // must be array AND two valid dates
      if (Array.isArray(param) && param.length === 2) {
        const d1 = new Date(param[0]);
        const d2 = new Date(param[1]);
        return !isNaN(d1) && !isNaN(d2);
      }
      return false;
    },
    getLabelNew(field) {
      const addressLineLabel = this.getAddressLineLabel(field);
      if (addressLineLabel) {
        return addressLineLabel;
      }

      // if(field=='property_name'){
      //   field="site_location_name";
      // }
      switch (field) {
        case "property_name":
          field = "site_location_name";
          break;
        case "job_title":
          field = "title";
          break;
        case "technician_barcode":
          return "Technician Barcode";
        case "visit_barcode":
          return "Visit Barcode";
        case "technician_name":
          return "Technician Name";
      }

      let returnType = this.lodash.capitalize(
        this.lodash
          .lowerCase(
            this.lodash
              .replace(field, "text", "name")
              .replaceAll("[barcode]", " #")
            // .replaceAll(field+"[barcode]", " #")
          )
          .replaceAll("barcode", `${this.pageModule} #`)
          .replaceAll("[", ` `)
          .replaceAll("]", ``)
      );
      if (field == "customer[barcode]") {
        returnType = "Customer #";
      }
      return returnType;
    },
    getFilterLabel(field) {
      //when search function clicks
      const addressLineLabel = this.getAddressLineLabel(field);
      if (addressLineLabel) {
        return addressLineLabel;
      }

      let child = [];
      let levelOne = field.split(".");
      let parent = levelOne[0].split("_").join(" ");
      if (levelOne[1]) {
        child.push(levelOne[1].split("_").join(" "));
      }
      if (child.length) {
        let childText = child.join(" ");
        return parent + "[" + childText + "]";
      }

      // console.log(this.pageModule);

      if (this.pageModule == "Invoice") {
        parent = this.lodash
          .replace(parent, "title", "title")
          .replaceAll("title", "title");
      }

      if (
        this.pageModule == "Preventive" ||
        this.pageModule == "Warranty" ||
        this.pageModule == "Equipment" ||
        this.pageModule == "Asset"
      ) {
        parent = this.lodash
          .replace(parent, "unique id", "serial no")
          .replaceAll("unique id", "serial no");
      }

      if (this.pageModule == "Site Location") {
        parent = this.lodash
          .replace(parent, "property_name", "site location name")
          .replaceAll("property_name", "site location name")
          .replaceAll("property name", `site location name`);
      }
      if (this.pageModule == "Quotation") {
        parent = this.lodash
          .replace(parent, "job_title", "title")
          .replaceAll("job_title", "title")
          .replaceAll("title", `title`);
      }

      parent = this.lodash
        .replace(parent, "zip_code", "postal code")
        .replaceAll("zip_code", `postal code`)
        .replaceAll("zip code", `postal code`);

      parent = this.lodash.lowerCase(parent);

      const result = this.lodash
        .replace(parent, "text", "name")
        .replaceAll("[barcode]", " #")
        .replaceAll("barcode", `${this.pageModule} #`);

      return result;
    },
    clearSearch(param) {
      SearchEventBus.$emit("clear-search", param || true);
    },
    advancedSearch() {
      SearchEventBus.$emit("advanced-search", true);
    },

    updateFields() {
      const _this = this;
      _this.searchParam = null;
      _this.listingSearch = new Object();

      if (
        _this.lodash.isEmpty(_this.$route.query) === false &&
        _this.$route.query.search
      ) {
        _this.searchParam = _this.$route.query.search;
      }

      if (
        _this.lodash.isEmpty(_this.$route.query) === false &&
        !_this.$route.query.search
      ) {
        for (let key in _this.$route.query) {
          if (_this.lodash.includes(_this.allowedSearchFields, key)) {
            if (_this.lodash.isString(_this.$route.query[key])) {
              _this.listingSearch[key] = _this.$route.query[key];
            } else if (
              _this.lodash.isEmpty(_this.$route.query[key]) === false
            ) {
              _this.listingSearch[key] = _this.$route.query[key];
            }
          }
        }
      }
    },
  },
  beforeDestroy() {
    this.listingSearch = new Object();
    this.searchParam = null;
  },
};
</script>

<style scoped>
.snackbar-full {
  position: absolute;
  bottom: 8px;
  width: 100%;
  z-index: 99;
  max-width: 75%;
  margin: auto;
  left: 0;
  right: 0;
}

.listing-search-card {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 10px !important;
  box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.1),
    0 4px 10px -2px rgba(15, 23, 42, 0.04) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.filter-header-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background-color: #e0f2fe;
}

.filter-header-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #1e293b;
}

.filter-count-chip {
  height: 20px !important;
  font-size: 11px !important;
  border: 1px solid #bae6fd !important;
  background-color: #e0f2fe !important;
}

.filter-chip {
  border: 1px solid #bae6fd !important;
  /* background-color: #f0f9ff !important; */
  background-color: #e0f2fe !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  height: 26px !important;
  transition: all 0.15s ease;
}

.filter-chip:hover {
  background-color: #e0f2fe !important;
  border-color: #7dd3fc !important;
}

.filter-chip-label {
  color: #0369a1;
}

.filter-chip-value {
  color: #0c4a6e;
  font-weight: 500;
}

.filter-btn-edit {
  border-radius: 6px !important;
  border: 1px solid #0284c7 !important;
  text-transform: none !important;
  letter-spacing: 0.2px;
  transition: all 0.2s ease;
}

.filter-btn-edit:hover {
  background-color: #f0f9ff !important;
}

.filter-btn-reset {
  border-radius: 6px !important;
  border: 1px solid #cbd5e1 !important;
  text-transform: none !important;
  letter-spacing: 0.2px;
  transition: all 0.2s ease;
}

.filter-btn-reset:hover {
  background-color: #f8fafc !important;
  color: #334155 !important;
}

.filter-action-btn {
  border-radius: 6px !important;
  transition: background-color 0.2s ease;
}

.filter-action-btn:hover {
  background-color: #f1f5f9 !important;
}
</style>
